import { gql } from '@apollo/client';

export const ACADEMIC_SSO_LINK_QUERY = gql`
  query ACADEMIC_SSO_LINK($academicPartnerId: String!, $guildUuid: String!) {
    ssoLinkData: AcademicService_getStudentSSOLink(
      academicPartnerId: $academicPartnerId
      guildUuid: $guildUuid
    ) {
      guildProgramName
      ssoLink
      expired
    }
  }
`;
